import { render, staticRenderFns } from "./TableTeacherList.vue?vue&type=template&id=794f2e56&scoped=true"
import script from "./TableTeacherList.vue?vue&type=script&lang=js"
export * from "./TableTeacherList.vue?vue&type=script&lang=js"
import style0 from "./TableTeacherList.vue?vue&type=style&index=0&id=794f2e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f2e56",
  null
  
)

export default component.exports